import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import type {
  SingleFavouriteListResponse,
  FavouriteList,
} from 'types/FavouriteList';
import { generateURL } from 'utilities/hooks/urlGeneration';
import { SPARK_RESOURCE_TYPES } from 'constants/common';

type mutationVariables = FavouriteList['id'];

export function useDeleteSparkFavourite() {
  const queryClient = useQueryClient();

  const deleteSparkFavourite = (sparkFavouriteListID: mutationVariables) => {
    if (!sparkFavouriteListID) {
      Promise.reject('listName can not be null');
    }

    const url = generateURL(
      SPARK_RESOURCE_TYPES.SPARK_FAVOURITES,
      [],
      sparkFavouriteListID
    );

    return fetchWrapper<SingleFavouriteListResponse>({
      url: url,
      method: 'DELETE',
    });
  };

  return useMutation('deleteSparkFavourite', deleteSparkFavourite, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(['sparks']);
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to Deleting spark favourite: ${error.message}`);
      }
    },
  });
}
